export const CONTENT_TYPE_STANDARD = "standard";

export const FIRST_SEARCH_COMPLETED_EVENT = "user_first_search_completed";
